import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FaQuoteLeft } from "react-icons/fa";


const TESTIMONIALS = [
  { name: "Mariana G.", text: "Gracias a Atlantis Fish, mi hijo tiene su primer acuario y ¡le fascina!" },
  { name: "Luis P.", text: "Excelente atención y los peces llegaron muy sanos. ¡Recomendados!" },
  { name: "Diana R.", text: "Me asesoraron en todo, mi acuario quedó hermoso y fácil de cuidar." },
  { name: "Paola T.", text: "Gran variedad de peces y siempre dan buenos consejos. Muy confiable." },
  { name: "Andrés M.", text: "Los insumos llegaron rápido y en excelente estado." },
  { name: "Carlos E.", text: "¡La mejor tienda de acuarios de Cúcuta! Me ayudaron con todo y resolvieron mis dudas." },
{ name: "Valentina S.", text: "Mi betta llegó en perfectas condiciones. Muy responsables, ¡los recomiendo!" },
{ name: "Ricardo F.", text: "Siempre compro mis accesorios aquí y nunca he tenido un problema. Excelente atención." },
{ name: "Sofía M.", text: "El filtro que compré funciona de maravilla. ¡Gracias por la asesoría!" },
{ name: "Julio A.", text: "Encontré peces que no conseguía en ninguna otra tienda. Gran variedad y precios justos." },
{ name: "Lorena T.", text: "El personal es muy amable y te explican todo paso a paso." },
{ name: "Samuel G.", text: "Compré mi primer acuario completo, todo llegó perfecto y listo para instalar." },
{ name: "Ana P.", text: "Me encantó la calidad de los productos y la rapidez en la entrega." },
{ name: "Oscar L.", text: "Pedí unas plantas acuáticas y llegaron verdes, sanas y listas para sembrar." },
{ name: "Mateo Z.", text: "¡Los mejores bettas! Los colores son impresionantes y vienen muy bien cuidados." },
{ name: "Viviana Q.", text: "Siempre atentos en WhatsApp, resolvieron todas mis preguntas antes de comprar." },
{ name: "Gustavo H.", text: "La galería de fotos me convenció y lo que recibí fue tal cual. Muy recomendado." },
{ name: "Paula N.", text: "Monté un acuario plantado gracias a sus recomendaciones y asesoría." },
{ name: "Javier R.", text: "Los precios son muy buenos para la calidad que ofrecen." },
{ name: "Camila C.", text: "Pedí un pedido grande y todo llegó súper bien empacado. ¡Gracias!" },
{ name: "Nelson D.", text: "La tienda online es fácil de usar y los métodos de pago son seguros." },
{ name: "Sara V.", text: "Me encantó la atención personalizada, me ayudaron a elegir peces compatibles." },
{ name: "Felipe I.", text: "¡Excelente experiencia! Compré alimento y accesorios y todo funciona perfecto." },
{ name: "Angie J.", text: "Siempre están innovando y trayendo nuevas especies. Me gusta mucho la tienda." },
{ name: "David O.", text: "Mi acuario luce hermoso gracias a los consejos que recibí." },
{ name: "Nicole S.", text: "Entrega rápida y peces en excelente estado, sin estrés." },
{ name: "Cristian B.", text: "Se nota la pasión por los peces. Recomiendo Atlantis Fish a todos mis amigos." },
{ name: "Patricia W.", text: "¡Por fin encontré una tienda donde se preocupan por el bienestar de los animales!" },
{ name: "Mauricio M.", text: "Gracias por ayudarme a solucionar un problema con mi filtro. Atención de 10." },
{ name: "Esteban Q.", text: "Los peces llegaron bien oxigenados y en bolsas seguras. ¡Muy pro!" },
{ name: "Daniela U.", text: "¡Tienen todo para el acuario! Desde grava hasta decoraciones hermosas." },
{ name: "Johana L.", text: "Me gusta que tengan garantía en sus productos. Muy confiable." },
{ name: "Julián G.", text: "Repetiré seguro. Mi familia quedó feliz con los nuevos peces." },
{ name: "Mónica F.", text: "Mi hija está feliz con su acuario, ¡gracias por el excelente servicio!" },
{ name: "Andrés Z.", text: "Me asesoraron en todo momento y el pedido llegó antes de lo esperado." },
{ name: "Vanessa C.", text: "Excelente servicio postventa, me ayudaron después de la compra." },
{ name: "Santiago T.", text: "Las plantas que compré crecieron rápido y se ven muy sanas." },
{ name: "Luisa R.", text: "Mi pedido llegó completo y bien protegido. Muy recomendados." },
{ name: "Sebastián D.", text: "Agradecido con la tienda, todo lo que ofrecen es de calidad." },
{ name: "Gloria M.", text: "¡No hay otra tienda igual en la ciudad! Atlantis Fish es la mejor." },
{ name: "Henry J.", text: "Me hicieron descuento por comprar varios productos. Súper atentos." },

  
];

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const TestimonialsSection = () => (
  <motion.section
    className="container mx-auto py-12"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeIn}
  >
    <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center">
      <span className="inline-block align-middle mr-2">💬</span>
      Testimonios de nuestros clientes
    </h2>
<Swiper
  modules={[Autoplay]}
  spaceBetween={32}
  slidesPerView={3}
  slidesPerGroup={3}
  autoplay={{ delay: 4000, disableOnInteraction: false }}
  loop
  breakpoints={{
    0:    { slidesPerView: 1, slidesPerGroup: 1 },
    640:  { slidesPerView: 2, slidesPerGroup: 2 },
    1024: { slidesPerView: 3, slidesPerGroup: 3 }
  }}
>
  {TESTIMONIALS.map((t, i) => (
    <SwiperSlide key={i}>
      <motion.div
        className="bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center text-center border hover:shadow-2xl transition-all h-full"
        whileHover={{ scale: 1.04 }}
      >
        <FaQuoteLeft className="text-blue-300 text-3xl mb-3" />
        <p className="text-gray-700 mb-6 text-lg leading-relaxed font-medium">"{t.text}"</p>
        <div className="font-bold text-blue-900 text-base mt-2">— {t.name}</div>
      </motion.div>
    </SwiperSlide>
  ))}
</Swiper>
  </motion.section>
);

export default TestimonialsSection;
